var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause9 = function SvgIconPause9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M34.5 0 0 34.5 34.5 69 69 34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M36.204 40H40V29h-3.796v11zM29 40h3.796V29H29v11z"
  }))));
};
export default SvgIconPause9;